module.exports = __webpack_public_path__ + "img/10874_L.2289d44e.png";